import { NextPage } from "next";
import Link from "next/link";
import Head from "next/head";
import classes from "../styles/pages/LegalPage.module.scss";

interface IConfidentialPageProps {}

const Confidential: NextPage<IConfidentialPageProps> = (props) => {
  const metaTitle = "Bivouac - Politique de confidentialité";
  const metaDescription =
    "Politique de confidentialité du site Bivouac.io, agence digitale et collectif d'explorateurs du web";
  return (
    <>
      <Head>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDescription} />
        <meta property="og:url" content="https://bivouac.io/mentions-legales" />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDescription} />
        <meta property="og:image" content="https://bivouac.io/og-picture.png" />
      </Head>
      <div className={classes["container"]}>
        <Link href="/">
          <a>
            <img
              className={classes["logo"]}
              src={"/logo-1.svg"}
              alt="Logo Bivouac"
            />
          </a>
        </Link>
        <h1 dir="ltr">Politique de confidentialité </h1>

        <h2 dir="ltr">1- Gestion des données personnelles</h2>

        <p>
          En France, les données personnelles sont notamment protégées par :
        </p>

        <ul>
          <li>
            <p>La loi n° 78-87 du 6 janvier 1978,</p>
          </li>
          <li>
            <p>La loi n° 2004-801 du 6 août 2004,</p>
          </li>
          <li>
            <p>L’article L. 226-13 du Code pénal,</p>
          </li>
          <li>
            <p>La Directive Européenne du 24 octobre 1995,</p>
          </li>
          <li>
            <p>
              Le règlement général sur la protection des données entré en
              vigueur le 25 mai 2018.
            </p>
          </li>
        </ul>

        <h2 dir="ltr">2- Comment sont collectées les données personnelles ?</h2>

        <p>
          Lorsque vous visitez le site bivouac.io, nous pouvons être amenés à
          collecter des données personnelles à des fins commerciales.
        </p>

        <p>Ces données sont collectées via un formulaire de contact :</p>

        <p>
          Le formulaire de contact et le chat qui collecte des informations
          (e-mail*, téléphone*) nous permettant d’échanger avec vous selon vos
          besoins exprimés dans ce formulaire.
        </p>

        <p>*Les données suivies d’un astérisque sont obligatoires.</p>

        <p>
          Lorsque vous complétez ce formulaire, vous acceptez l’utilisation de
          vos données personnelles aux fins prévues par celui-ci.
        </p>

        <h2 dir="ltr">3- Vos données peuvent-elles être partagées ?</h2>

        <p>
          Ces données personnelles ne seront en aucun cas vendues à des tiers.
          Cependant, celles-ci peuvent être partagées en interne entre les
          partis-prenantes de la société Bivouac afin de vous apporter des
          informations complémentaires.
        </p>

        <h2 dir="ltr">4- Combien de temps conservons-nous vos données ?</h2>

        <p>
          Vos données personnelles sont conservées par nos équipes pendant le
          temps nécessaire au traitement de la demande qui nous a permis de les
          collecter. En conformité avec la loi, lorsque ces données personnelles
          ne sont plus requises dans le but pour lequel elles ont été
          collectées, elles seront effacées.
        </p>

        <p>
          Les données de prospects n’ayant pas donné suite à nos sollicitations
          commerciales seront effacées après au maximum 3 ans, sauf s’ils
          manifestent explicitement leur volonté de continuer à recevoir nos
          envois.
        </p>

        <h2 dir="ltr">5- Vos droits vis-à-vis de vos données personnelles</h2>

        <p>
          Conformément à la loi informatique et libertés du 6 janvier 1978 et au
          règlement général sur la protection des données qui est entré en
          vigueur le 25 mai 2018, vous disposez d’un droit d’accès, de
          rectification et d’effacement de vos données personnelles. Vous pouvez
          exercer ce droit en contactant{" "}
          <a href="mailto:mail@bivouac.io">mail@bivouac.io</a> . Nous nous
          efforcerons de répondre aux demandes dans les meilleurs délais.
        </p>

        <h2 dir="ltr">6- Liens hypertextes et cookies</h2>

        <p>
          Le site bivouac.io pourrait à terme, contenir un certain nombre de
          liens hypertextes vers d’autres sites, mis en place avec
          l’autorisation de Bivouac. Cependant, Bivouac n’a pas la possibilité
          de vérifier le contenu des sites ainsi visités, et n’assumera en
          conséquence aucune responsabilité de ce fait.
        </p>

        <p>
          Nous ne collectons pas des données via des cookies sur notre site
          internet, nous avons décidé de ne pas installer des cookies sur notre
          site internet.
        </p>

        <br />
      </div>
    </>
  );
};
export default Confidential;
